// extracted by mini-css-extract-plugin
export var list = "timeline-list-module--list--M3hZ5";
export var item = "timeline-list-module--item--PMN7B";
export var spacing = "timeline-list-module--spacing--bceaC";